import { cachedAPIWrapper, getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { apiConfig } from "../config/apiConfig";
import { isTouchDevice } from "../util/device-detection";
import { isOperationActiveNow } from "../util/share";
/**
 * Special offer popup.
 */
export class SpecialOfferPopUp {

    localStorageKey = 'specialOffer';
    sessionStorageKey = 'specialOfferEnabled'
    isPopupShown = false;
    time = 600;
    isApiLoaded = false;
    delayTimer!: ReturnType<typeof setTimeout>
    private static instance: SpecialOfferPopUp;
    private specialOfferMarkupDom: HTMLDivElement | null;
    static getInstance(): SpecialOfferPopUp {
        if (!SpecialOfferPopUp.instance) {
            SpecialOfferPopUp.instance = new SpecialOfferPopUp()
        }
        return SpecialOfferPopUp.instance;
    }

    constructor() {
        this.specialOfferMarkupDom = document.getElementById('sp-offer-new') as HTMLDivElement;
        this.isPopupShown = sessionStorage.getItem(this.sessionStorageKey) === 'true'
        if (this.isPopupShown) return;
        const startTime = localStorage.getItem(this.localStorageKey);
        if (startTime == undefined) {
            localStorage.setItem(this.localStorageKey, String(Date.now()));
            sessionStorage.setItem(this.sessionStorageKey, String(this.isPopupShown));
        } else {
            const currentTime = Date.now();
            const startTime = Number(localStorage.getItem(this.localStorageKey));
            this.time = 600 - Math.floor((currentTime - startTime) / 1000);
            if(this.time < 0){
                this.isPopupShown = true;
                sessionStorage.setItem(this.sessionStorageKey, String(this.isPopupShown));
                localStorage.removeItem(this.localStorageKey)
                return;
            }
        }
        this.close = this.close.bind(this);
        this.init();
    }

    checkIfLocalUserInNational() {
        const isUserLocallized = !!localStorage.getItem('dbaName');
        if (!isUserLocallized)
            return false
        const rawString = document.getElementById('page-settings') as HTMLInputElement;
        const pageScope = rawString?.outerHTML.split('"pagescope":"')[1].split(',')[0].trim().replace(/["=]/g, '') ?? "N/A";
        const dbaName = localStorage.getItem('dbaName')
        if (dbaName && pageScope === 'national') {
                return true
        }
        return false;
    }

    init() {
        const pageSettings = document.getElementById('page-settings') as HTMLDivElement
        if (!this.specialOfferMarkupDom || !pageSettings) return;
        const showOfferPopUp = pageSettings.outerHTML.split('showspecialofferpopup')[1]?.slice(2, 6)
        const franchiseWebLocationId = localStorage.getItem('franchiseWebLocationId')
        const dbaName = localStorage.getItem('dbaName') as string;
        if (showOfferPopUp === "false") {
            this.specialOfferMarkupDom?.classList.add('hidden'); 
            this.specialOfferMarkupDom?.classList.remove('flex');
            if (this.specialOfferMarkupDom) {
                this.specialOfferMarkupDom.style.backgroundColor = "";
                document.body.style.overflow = '';
            }
            this.isApiLoaded = false;
            return;
        }
        const isLocalizedUserInNational = this.checkIfLocalUserInNational()
        if (isLocalizedUserInNational && showOfferPopUp === "true" && dbaName && franchiseWebLocationId) {
            const url = `${window.location.origin}/localspecialofferpopup/${franchiseWebLocationId}/${dbaName}`
            getCachedAPIResponse(url).then((response: string) => {
                if (!response.length) {
                    this.specialOfferMarkupDom?.classList.add('hidden');
                    this.specialOfferMarkupDom?.classList.remove('flex');
                    if (this.specialOfferMarkupDom) {
                        this.specialOfferMarkupDom.style.backgroundColor = "";
                        document.body.style.overflow = '';
                    }
                    this.isApiLoaded = false;
                    return;
                }
                this.isApiLoaded = true;
                (this.specialOfferMarkupDom as HTMLDivElement).outerHTML = response
                //Need to reassign the reference
                this.specialOfferMarkupDom = document.getElementById('sp-offer-new') as HTMLDivElement;
            })
        }
        this.delayTimer = setTimeout(() => {
            this.isPopupShown = true;
            sessionStorage.setItem('specialOfferEnabled', String(this.isPopupShown))
            if (isLocalizedUserInNational) {
                if(!this.isApiLoaded) return;
            }
            this.getSpecialOfferMarkup();
        }, 10000);
        this.addMouseLeaveListener(); 
    }

    addMouseLeaveListener() {
        document.addEventListener("mouseleave", () => {
            if (sessionStorage.getItem(this.sessionStorageKey) === 'true') {
                return;
            }
            if (!this.checkIfLocalUserInNational()) {
                clearTimeout(this.delayTimer)
                this.isPopupShown = true;
                sessionStorage.setItem(this.sessionStorageKey, "true");
                this.getSpecialOfferMarkup();
                return;
            }
            if (!this.isApiLoaded) return;
            clearTimeout(this.delayTimer)
            this.isPopupShown = true;
            sessionStorage.setItem(this.sessionStorageKey, "true");
            this.getSpecialOfferMarkup();
        });
    }

    private async getFullAttributeData() {
        if (localStorage.getItem("fullAttrOnLoad")) return localStorage.getItem("fullAttrOnLoad");
    
        try {
            const webId = ((document.getElementById('weblocationId') as HTMLInputElement)?.value ?? localStorage.getItem("franchiseWebLocationId"));
    
            if (webId && webId !== "null" && webId !== "") {
                const url = `${apiConfig.GET_ATTRIBUTE_DATA}/${webId}`;
                const response = await cachedAPIWrapper(url);
                localStorage.setItem("fullAttrOnLoad", JSON.stringify(response));
                return JSON.stringify(response);
            }
        } catch (error) {
            console.error('Error fetching full attribute data:', error);
        }
        return null;
    }
    private handleButtonVisibility(isActive: boolean) {
        const clickToCall = document.querySelector('.sp-offer-full-info .secondary-btn') as HTMLElement;
        const bookNowbtn = document.querySelector('.sp-offer-full-info .primary-btn') as HTMLElement;
    
        //ClickToCall Only for mobile devices
        if (isTouchDevice()) {
            if (isActive && clickToCall) {
                clickToCall.style.display = 'flex';  
                if (bookNowbtn) bookNowbtn.style.display = 'none';
            } else {
                if (clickToCall) clickToCall.style.display = 'none'; 
                if (bookNowbtn) bookNowbtn.style.display = 'flex';
            }
        }
    }
    async getSpecialOfferMarkup() {

        let fullAttrOnLoad = await this.getFullAttributeData();

        const isActive = fullAttrOnLoad ? isOperationActiveNow(JSON.parse(fullAttrOnLoad)?.hoursofOperation) : false;
      
        this.specialOfferMarkupDom?.classList.remove('hidden');
        this.specialOfferMarkupDom?.classList.add('flex');
      
        this.handleButtonVisibility(isActive);

        if (this.specialOfferMarkupDom) {
            this.specialOfferMarkupDom.style.backgroundColor = "#00000066";
            document.body.style.overflow = 'hidden';
        }
        const closeButton = document.querySelector('#sp-offer-new .close-modal-btn')
        closeButton?.addEventListener('click', this.close)
        const bookNow = document.querySelector('#sp-offer-new .primary-btn') as HTMLAnchorElement | undefined
        bookNow?.addEventListener('click', (e) => {
            e.preventDefault();
            const saveInSessionStorage = () => {
                const title = document.getElementsByClassName('sp-offer-heading')[0]
                const description = document.getElementsByClassName('sp-offer-text')[0];
                const couponInput = document.querySelector('.sp-offer-modal #special-offer-coupon-code') as HTMLInputElement;
                const couponCode = (couponInput && couponInput.value.trim() !== '') ? couponInput.value.trim() : '';
                //Store the offer details if any of them exists. couponcode is an optional value
                if (!title && !description && !couponCode) return;
                sessionStorage.setItem('offerDetails', JSON.stringify({
                    title: title.innerHTML,
                    description: description.innerHTML,
                    couponexpirydate: '',
                    longdescription: '',
                    couponcode: couponCode
                }))
            }
            saveInSessionStorage()
            window.location.href = (e.target as HTMLAnchorElement).href
        })
        this.startTimer();
    }

    startTimer() {
        const time = {
            minutes: document.getElementById('sp-minutes') as HTMLSpanElement,
            seconds: document.getElementById('sp-seconds') as HTMLSpanElement
        }
        if (!time.minutes || !time.seconds) return;
        const interval = setInterval(() => {
            if (this.time == 0) {
                this.close();
                clearInterval(interval)
                return;
            }
            const min = Math.floor(this.time / 60);
            const sec = this.time % 60;
            time.minutes.innerText = `${min < 10 ? '0' : ''}${min}`;
            time.seconds.innerText = `${sec < 10 ? '0' : ''}${sec}`;
            this.time = this.time - 1;
        }, 1000);
    }

    close() {
        this.specialOfferMarkupDom?.classList.add('hidden');
        this.specialOfferMarkupDom?.classList.remove('flex');
        if (this.specialOfferMarkupDom) {
            this.specialOfferMarkupDom.style.backgroundColor = "";
            document.body.style.overflow = '';
        }
        localStorage.removeItem(this.localStorageKey);
        this.isPopupShown = true;
        sessionStorage.setItem('specialOfferEnabled', String(this.isPopupShown))
        this.time = 600;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const specialOfferMarkupDom = document.getElementById('sp-offer-new')
    if (!specialOfferMarkupDom) return;
    SpecialOfferPopUp.getInstance();
})


